// @core/api/endpoints/chat/list_message_readers.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListMessageReadersResponse,
} from '../../../types/chat';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/chat';

/**
 * List message readers
 * Returns the list of profiles who have read a specific message, each with the timestamp of first read.
 */
export async function ListMessageReaders(
  conversation_id: string,
  message_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListMessageReadersResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/messages/:message_id/readers`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  requestPath = requestPath.replace(':message_id', encodeURIComponent(message_id));
  const requestOptions = options;
  return client.get<ListMessageReadersResponse>(requestPath, { ...requestOptions, params });
}
